import { AuthAdapterInvoicePayment } from '../../types';
import { Tokens } from '../../../AuthenticationService/types';
import { signInWithEmailLink, signInWithEmailAndPassword, signInWithCustomToken as signInWithCustomFirebaseToken,
} from 'firebase/auth';
import { auth } from '../../../../firebase';
import config from '../../../../config';
import { FirebaseAuthAdapterBase } from '../../../AuthenticationService/authAdapters/FirebaseApiAdapter/FirebaseAuthAdapterBase';

class FirebaseAuthAdapter extends FirebaseAuthAdapterBase
  implements AuthAdapterInvoicePayment {
  async signInWithPassword(email: string, password: string): Promise<Tokens> {
    try {
      auth.tenantId = config.firebase.invoicePortalTenentId;
      const resp = await signInWithEmailAndPassword(auth, email, password);
      return await this.buildToken(resp.user);
    } catch (err) {
      throw this.getError(err);
    }
  }

  async signInWithEmailLink(email: string): Promise<Tokens> {
    try {
      auth.tenantId = config.firebase.invoicePortalTenentId;
      const resp = await signInWithEmailLink(auth, email, window.location.href);
      return await this.buildToken(resp.user);
    } catch (err) {
      throw this.getError(err);
    }
  }

  async signInWithCustomToken(token: string): Promise<Tokens> {
    try {
      auth.tenantId = config.firebase.invoicePortalTenentId;      
      const resp = await signInWithCustomFirebaseToken(auth, token);
      const response = await this.buildToken(resp.user);
      return response;

    } catch (err) {
      throw this.getError(err);
    }
  }

  async refreshTokens(): Promise<Tokens> {
    try {
      auth.tenantId = config.firebase.invoicePortalTenentId;
      await auth.currentUser?.getIdToken(true); //Force Refresh
      return await this.buildToken(auth.currentUser!);
    } catch (err) {
      throw this.getError(err);
    }
  }
}

export default FirebaseAuthAdapter;
